import { z } from 'zod';

export const znum = z.number();
export const znumn = znum.nullable();
export const znumo = znum.optional();
export const zstr = z.string().trim();
export const zstro = zstr.optional();
export const zstrn = zstr.nullable();
export const zany = z.any();
export const numify = zstr.transform((v: string) => Number(v));
export const zbool = z.boolean();
export const zbooln = z.boolean().nullable();
export const zboolo = zbool.optional();
export const zobj = <T extends z.ZodRawShape>(val: T) => z.object(val);
export const zobjo = <T extends z.ZodRawShape>(val: T) => zobj(val).optional();
export const zarr = <T extends z.ZodTypeAny>(val: T) => z.array(val);
export const zarro = <T extends z.ZodTypeAny>(val: T) => zarr(val).optional();
export const zcusn = <T>() => z.custom<T>().nullable(); // for dropdowns null or given type. does not validate, only for info.
export const zdaten = z.date().nullable();
